import { StandardProps } from "@/components/componentMap";
import { Price } from "@/components/Price/Price";
import { PricePromise } from "@/components";
import classNames from "classnames/bind";
import styles from "./PriceAndPricePromise.module.scss";

const cx = classNames.bind(styles);

export function PriceAndPricePromise({
  product,
  configProps,
  flags,
  runtimeConfig,
  experiencesRawObject,
}: Pick<
  StandardProps,
  "product" | "configProps" | "flags" | "runtimeConfig" | "experiencesRawObject"
>) {
  const wrapOnMobile = Boolean(configProps?.wrapOnMobile);

  return (
    <div
      className={cx(styles.container, {
        wrapOnMobile: wrapOnMobile,
      })}
      data-testid="price-and-price-promise"
      data-component="PriceAndPricePromise"
    >
      <Price
        product={product}
        configProps={configProps}
        flags={flags}
        runtimeConfig={runtimeConfig}
        experiencesRawObject={experiencesRawObject}
      />
      <PricePromise product={product} flags={flags} isInGroup={true} />
    </div>
  );
}
